import React, { useContext, useState } from "react";
import { useFormikContext, Field, ErrorMessage } from "formik";
import { Context } from "../inc/state";
import { SelectInput, Radio, FieldWrapper, MaskedInput } from "./fields";
import { normalizeField } from "../inc/functions";
import countries from "../inc/countries";
import errorMessages from "../inc/errorMessages";
import * as Yup from "yup";

export const LegalEntityFormSchema = Yup.object().shape({
	rechtsvorm: Yup.string().required(errorMessages.required),
	rechtsvormAndere: Yup.string().when("rechtsvorm", {
		is: "Andere",
		then: Yup.string().required(errorMessages.required),
	}),
});

export const LegalEntitySchema = Yup.object().shape({
	naam: Yup.string().required(errorMessages.required),
	btwNumber: Yup.string().required(errorMessages.required),
	straat: Yup.string().required(errorMessages.required),
	huisnummer: Yup.string().required(errorMessages.required),
	postcode: Yup.string().required(errorMessages.required),
	gemeente: Yup.string().required(errorMessages.required),
});

const LegalForm = ({ group = "" }) => {
	const [option, setOption] = useState("");
	const options = [
		"Vennootschap onder firma",
		"Besloten vennootschap",
		"Commanditaire vennootschap",
		"Naamloze vennootschap",
		"Vereniging zonder winstoogmerk",
		"Stichting",
		"Coöperatieve vennootschap",
		"Andere",
	];
	return (
		<>
			<label htmlFor={`${group}rechtsvorm`} className="mb-2">
				Rechtsvorm
			</label>

			<div className="mb-3">
				{options.map((el, index) => (
					<Radio
						name={`${group}rechtsvorm`}
						value={el}
						id={`${group}rechtsvorm.${index}`}
						key={`${group}rechtsvorm.${index}`}
						label={el}
						required={true}
						onClick={(e) => {
							setOption(e.target.value);
						}}
					/>
				))}
			</div>

			<ErrorMessage name={`${group}rechtsvorm`}>
				{(msg) => <div className="invalid-feedback d-block mb-3">{msg}</div>}
			</ErrorMessage>

			{option === "Andere" && (
				<FieldWrapper id={`${group}rechtsvormAndere`} name={`${group}rechtsvormAndere`} />
			)}
		</>
	);
};

export default ({ group = "", showLegalForm = true, isBelgium = false }) => {
	const { values } = useFormikContext();

	const fields = [
		{
			name: "naam",
			label: "Naam van de rechtspersoon",
			text: "Naam van de rechtspersoon waarmee u zal investeren.",
			required: true,
		},
		{
			name: "btwNumber",
			label: "BTW nummer, voorafgegaan door de landcode, bijvoorbeeld BE",
			required: true,
		},
		{ name: "land", label: "Land waar de zetel gevestigd is", type: "country", required: true },
		{
			name: "straat",
			label: "Straat van de zetel",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? /^[a-zA-Z\s]*$/ : String,
		},
		{
			name: "huisnummer",
			label: "Huisnummer van de zetel",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? Number : String,
		},
		{
			name: "bus",
			label: "Bus van de zetel",
			required: false,
		},
		{
			name: "postcode",
			label: "Postcode van de zetel",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? Number : String,
		},
		{
			name: "gemeente",
			label: "Gemeente of stad van de zetel",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? /^[a-zA-Z\s]*$/ : String,
		},
	].map(normalizeField);

	return (
		<>
			{showLegalForm && <LegalForm group={group} />}

			{fields.map((field, index) => (
				<React.Fragment key={`${group}personalFields.${index}`}>
					{field.type === "maskedInput" && (
						<MaskedInput
							mask={field.mask}
							id={`${group}${field.id}`}
							name={`${group}${field.name}`}
							text={field.text}
							label={field.label}
							required={field.required}
						/>
					)}

					{field.type.match(/text|email|number/g) && (
						<FieldWrapper
							id={`${group}${field.id}`}
							name={`${group}${field.name}`}
							type={field.type}
							text={field.text}
							label={field.label}
							required={field.required}
						/>
					)}

					{field.type === "country" && (
						<SelectInput
							id={`${group}${field.id}`}
							name={`${group}${field.name}`}
							placeholder="Selecteer land"
							options={countries}
							label={field.label}
							required={field.required}
						/>
					)}
				</React.Fragment>
			))}
		</>
	);
};
